import { mapMutations, mapState } from 'vuex';
import createExtend from '@/components/createExtend';
import ExistRepeatPic from '@C/ExistRepeatPic';

export const pageInation = {
  data() {
    return {
      whiteListRoute: [
        '/operation/newsPushNewsList',
        '/train/class',
        '/operation/keyword',
        '/operation/banner',
        '/operation/codeRed',
        '/operation/codeRed',
        '/operation/floating',
        '/content/channelVideoList',
        '/content/channelInforCaseList',
        '/content/materialList',
        '/content/faceList',
        '/onlinePromotion/extension/list',
        '/onlinePromotion/content/list',
        '/onlinePromotion/zone/list',
        '/train/class/child/course-list',
        '/train/class/child/students-list',
        '//four'
      ], // 因为 列表 会有 子集列表 导致子集分页存储值不服会重复请求2此 如父列表第2页 子列表只有1页 因为通用一套分页 导致父进子列表请求两次
      loading: false, //  table加载loading
      tableData: [], // 列表数据LIST
      tableResp: {}, // 列表数据 DATA
      totalPages: 0, // 总页数
      totalElements: 0, //总条数
      paginationData: {
        //提交分页数据
        pageNo: 1, // 当前页
        pageSize: 15 // 每页显示条
      },
      callback: '', // 回调
      childNotSetPageNumStoreFlag: false // 替代whiteListRoute
    };
  },
  computed: {
    ...mapState({
      num: state => state.pageNum.num // 修改后 转跳列表时保存上次进入时的页码
    })
  },
  methods: {
    ...mapMutations(['SET_PAGENUM']),
    checkIfSign() {
      this.$confirm('请在新打开的页面完成签约，签约成功请点击完成', '提示', {
        confirmButtonText: '完成',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.initWatchRouteChange();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
          this.initWatchRouteChange();
        });
    },

    // 平滑回到顶部
    toTop() {
      let gotoTop = () => {
        let currentPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
        currentPosition -= 10;
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition);
        } else {
          window.scrollTo(0, 0);
          clearInterval(timer);
          timer = null;
        }
      };
      let timer = setInterval(gotoTop, 1);
    },
    // 保存成功后的回掉
    saveSuccess(toTop = false, val) {
      this.getPageList(this.num || val || 1, toTop);
    },
    handleSizeChange(val) {
      this.paginationData.pageSize = val;
      this.paginationData.pageNo = 1;
      this.getPageList(1);
    },
    // 换页
    handleCurrentChange(val) {
      this.paginationData.pageNo = val;
    },
    /**
     * @description: 初始化 分页数据 需要传入列表数据
     * @param {array, number, boolean}
     * @return: void
     */
    initPage(resp, pageNo, toTop) {
      this.totalElements = resp.total;
      this.tableResp = resp;
      if (resp.totalPrice) {
        this.totalMoney = resp.totalPrice;
      }
      this.tableData = resp.list !== void 0 ? resp.list || [] : resp;
      if (this.fenqiPageChange) {
        this.fenqiPageChange();
      }
      if (this.preDealTableData) {
        this.preDealTableData(resp);
      }
      this.loading = false;
      toTop && this.toTop();
      this.$nextTick(() => {
        this.fkElementPaginationInitCurrentNo(pageNo, toTop);
        if (this.methodCallback && typeof this.methodCallback == 'function') {
          this.methodCallback();
        }
        this.$emit('respondFinished', resp);
        this.$refs.table.doLayout();
      });
    },
    // cao currentPage 赋值不触发element组件  暂时直接调用内部方法
    fkElementPaginationInitCurrentNo(pageNo) {
      this.$children.forEach(item => {
        if (item.$options.name == 'ElPagination') {
          item.handleCurrentChange(pageNo);
        }
      });
    },
    // 搜索 传递搜索参数
    searchEvent() {
      this.getPageList(1);
      // this.paginationData.pageNum = 1
    },
    // route 改变后 初始化数据
    initWatchRouteChange(pageNo = 1) {
      this.getPageList(pageNo);
    },
    /**
     * @description: 对应分页加载处理
     * @param {Number} 当前页码 默认1
     * @param {Boolean} 是否滚动置顶
     * @return:
     */
    getPageList(pageNo = 1, toTop = true, moreParams) {
      this.loading = true;
      // getList 为page页面传进来的方法
      this.paginationData.pageNo = pageNo;
      if (typeof this.getList == 'function') {
        let query = {
          ...this.paginationData,
          ...this.searchQuery,
          ...moreParams
        };
        if (typeof this.$attrs['beforeGetList'] === 'function') {
          try {
            let resolved = this.$attrs['beforeGetList']({
              query: query,
              name: this.getList.name
            });
            resolved && (query = resolved);
          } catch (err) {
            // console.log(err);
          }
        }
        this.getList(query)
          .then(res => {
            let resp = res.data.data;
            // 添加钩子函数
            if (typeof this.$attrs['beforeInitPage'] === 'function') {
              try {
                let resolved = this.$attrs['beforeInitPage']({
                  respond: resp,
                  name: this.getList.name
                });
                resolved && (resp = resolved);
              } catch (err) {
                // console.log(err);
              }
            }

            // 添加钩子函数
            if (typeof this.getListFinished === 'function') {
              try {
                this.getListFinished(resp, pageNo, toTop, query);
              } catch (err) {
                // console.log(err);
              }
            }

            // 自定义数据整理
            if (typeof this.formatDataMethod === 'function') {
              resp = this.formatDataMethod(res.data.data);
            }
            this.initPage(resp, pageNo, toTop);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    }
  },

  watch: {
    'paginationData.pageNo'(n) {
      // 如果是子列表 默认进入就是第一页 并且不改变 全局分页的当前页数
      // 以后使用childSetPageNumStoreFlag 替换 whiteListRoute
      if (!this.loading) {
        this.getPageList(n);
      }
      // childNotSetPageNumStoreFlag true则不需要更改store 默认false
      if (!this.childNotSetPageNumStoreFlag) {
        this.SET_PAGENUM(n);
        return false;
      }
      // whiteListRoute 名单中则不会更改store
      // 存在是为了兼容之前
      if (!this.whiteListRoute.includes(this.$route.path)) {
        this.SET_PAGENUM(n);
      }
    }
  },
  beforeMount() {
    // 初始化数据与分页
    if (this.setPageSize) {
      this.paginationData.pageSize = this.setPageSize;
    }
    if (this.num > 1) {
      let pageNo = this.childNotSetPageNumStoreFlag
        ? 1
        : !this.whiteListRoute.includes(this.$route.path)
        ? this.num
        : 1;
      this.paginationData.pageNo = pageNo;
      if (this.paginationData.pageNo === 1) {
        this.getPageList(1);
      }
    } else {
      this.getPageList(1);
    }
  },
  mounted() {
    setTimeout(() => {
      // 显示 包含重复图片的提示文案
      const repeatPic = this.$refs['ExistRepeatPic'];
      if (repeatPic) {
        createExtend(ExistRepeatPic, {}, repeatPic);
      }
    }, 60);
    // console.log('this.getListFinished');
    // console.log(this);
    // console.log(this.getListFinished);
  }
};
